 function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import React, {useMemo} from 'react'
import useAtmosphere from '~/hooks/useAtmosphere'
import useRouter from '~/hooks/useRouter'
import constructFilterQueryParamURL from '~/utils/constructFilterQueryParamURL'
import {useQueryParameterParser} from '~/utils/useQueryParameterParser'

import DropdownMenuLabel from './DropdownMenuLabel'
import Menu from './Menu'
import MenuItem from './MenuItem'
import TimelineEventTypeEnum from '../../server/graphql/types/TimelineEventTypeEnum'
import EventTypeFilterMenuItemLabel from './EventTypeFilterMenuItemLabel'





const TimelineEventTypeMenu = (props) => {
  const {history} = useRouter()
  const {menuProps} = props
  const atmosphere = useAtmosphere()
  const eventTypes = TimelineEventTypeEnum.getValues().map(({value}) => value)
  const {
    eventTypes: eventTypeFilters,
    teamIds,
    userIds
  } = useQueryParameterParser(atmosphere.viewerId)

  const {eventTypeValues, defaultActiveIdx} = useMemo(() => {
    const eventTypeValues = eventTypes
    return {
      eventTypeValues,
      defaultActiveIdx:
        eventTypeValues.findIndex((eventType) => _optionalChain([eventTypeFilters, 'optionalAccess', _ => _.includes, 'call', _2 => _2(eventType)])) + 2
    }
  }, [eventTypeFilters])

  return (
    React.createElement(Menu, {
      keepParentFocus: true,
      ariaLabel: 'Select the even type to filter by',
      ...menuProps,
      defaultActiveIdx: defaultActiveIdx,}

      , React.createElement(DropdownMenuLabel, null, 'Filter by event type:')
      , React.createElement(MenuItem, {
        key: 'eventTypeFilterNULL',
        label: React.createElement(EventTypeFilterMenuItemLabel, null ),
        onClick: () => history.push(constructFilterQueryParamURL(teamIds, userIds)),}
      )
      , eventTypeValues.map((eventType, index) => {
        return (
          React.createElement(MenuItem, {
            key: `eventTypeFilter${eventType}-${index}`,
            label: React.createElement(EventTypeFilterMenuItemLabel, { eventType: eventType,} ),
            onClick: () =>
              history.push(constructFilterQueryParamURL(teamIds, userIds, undefined, [eventType]))
            ,}
          )
        )
      })
    )
  )
}

export default TimelineEventTypeMenu
